import axios from "axios";

// Empty / unset REACT_APP_API_URL = same-origin (/v1/). Required so one
// GHCR image works on both stag.render.fm and render.fm behind the ingress.
const configured = process.env.REACT_APP_API_URL;
export const API_ORIGIN = configured ? configured.replace(/\/$/, "") : "";

export const BASE_URL = API_ORIGIN ? `${API_ORIGIN}/v1/` : "/v1/";

export const Api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 60000, // 60 second timeout for all requests
});

// Request interceptor - Add auth token to requests
Api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle errors centrally
Api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle network errors
    if (!error.response) {
      if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
        error.message = 'Request timed out. Please check your connection and try again.';
      } else {
        error.message = 'Network error. Please check your connection and try again.';
      }
      return Promise.reject(error);
    }

    // Handle HTTP errors
    const status = error.response?.status;
    const data = error.response?.data;

    // Handle 401 Unauthorized - token expired or invalid
    if (status === 401) {
      // Clear tokens and redirect to login
      localStorage.removeItem("authToken");
      localStorage.removeItem("refreshToken");
      // Only redirect if we're not already on an auth page
      if (!window.location.pathname.includes('/auth/')) {
        window.location.href = '/auth/login';
      }
    }

    // Handle 403 Forbidden
    if (status === 403) {
      error.message = data?.message || 'You do not have permission to perform this action.';
    }

    // Handle 404 Not Found
    if (status === 404) {
      error.message = data?.message || 'The requested resource was not found.';
    }

    // Handle 429 Too Many Requests
    if (status === 429) {
      error.message = data?.message || 'Too many requests. Please try again later.';
    }

    // Handle 500+ Server Errors
    if (status >= 500) {
      error.message = data?.message || 'Server error. Please try again later.';
    }

    // For other errors, use the message from the API or a generic message
    if (!error.message || error.message === 'Network Error') {
      error.message = data?.message || `Request failed with status ${status}`;
    }

    return Promise.reject(error);
  }
);
